/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The orientation of the LTU.
 */
export const AnimaticLTUConfigOrientation = {
  Horizontal: "horizontal",
  Vertical: "vertical",
} as const;
/**
 * The orientation of the LTU.
 */
export type AnimaticLTUConfigOrientation = OpenEnum<
  typeof AnimaticLTUConfigOrientation
>;

/**
 * The configuration of the animatic for a LTU.
 */
export type AnimaticLTUConfig = {
  /**
   * The orientation of the LTU.
   */
  orientation?: AnimaticLTUConfigOrientation | undefined;
};

/** @internal */
export const AnimaticLTUConfigOrientation$inboundSchema: z.ZodType<
  AnimaticLTUConfigOrientation,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AnimaticLTUConfigOrientation);
/** @internal */
export const AnimaticLTUConfigOrientation$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AnimaticLTUConfigOrientation
> = openEnums.outboundSchema(AnimaticLTUConfigOrientation);

/** @internal */
export const AnimaticLTUConfig$inboundSchema: z.ZodType<
  AnimaticLTUConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  orientation: AnimaticLTUConfigOrientation$inboundSchema.default("vertical"),
});
/** @internal */
export type AnimaticLTUConfig$Outbound = {
  orientation: string;
};

/** @internal */
export const AnimaticLTUConfig$outboundSchema: z.ZodType<
  AnimaticLTUConfig$Outbound,
  z.ZodTypeDef,
  AnimaticLTUConfig
> = z.object({
  orientation: AnimaticLTUConfigOrientation$outboundSchema.default("vertical"),
});

export function animaticLTUConfigToJSON(
  animaticLTUConfig: AnimaticLTUConfig,
): string {
  return JSON.stringify(
    AnimaticLTUConfig$outboundSchema.parse(animaticLTUConfig),
  );
}
export function animaticLTUConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticLTUConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticLTUConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticLTUConfig' from JSON`,
  );
}
